const EmailSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={31} height={31} x={0.5} y={0.5} fill="#fff" rx={15.5} />
    <rect width={31} height={31} x={0.5} y={0.5} stroke="#D3D3D3" rx={15.5} />
    <path
      fill="#909090"
      fillRule="evenodd"
      d="M10.34 20.846c-.032 0-.06-.017-.092-.02l4.07-4.084 1.356 1.39a.455.455 0 0 0 .657 0l1.354-1.39 4.068 4.085c-.03.003-.056.02-.088.02H10.34Zm-.842-.635a.962.962 0 0 1-.06-.309v-7.805c0-.106.027-.204.058-.3l4.147 4.255-4.145 4.16Zm12.164-9.057c.035 0 .064.015.098.02l-5.762 5.916-5.765-5.915c.036-.005.067-.021.103-.021h11.326Zm.897.943v7.805c0 .11-.027.215-.061.313l-4.145-4.163 4.147-4.259c.032.097.059.196.059.304Zm-.896-1.93H10.337c-1.013 0-1.837.866-1.837 1.93v7.805c0 1.064.824 1.931 1.837 1.931h11.326c1.013 0 1.837-.866 1.837-1.93v-7.806c0-1.064-.824-1.93-1.837-1.93Z"
      clipRule="evenodd"
    />
  </svg>
)
export { EmailSvg }
